//permission based on CONTACT GROUP

import { IPermissionState } from "../store/reducers/permissionReducer";

type Role = keyof typeof ROLES;
type Permission = (typeof ROLES)[Role][number];

const ROLES = {
  "Inception Financial": [""],
  "AmpVantage Energy": ["showEmptyMyDocument"],
  "Inception Financial Referral": [""],
} as const;

export function contactGroupPermission(
  user: IPermissionState,
  permission: Permission
) {
  if (!user?.contactGroup) return false;
  const contactGroup = user.contactGroup as keyof typeof ROLES;
  if (!ROLES[contactGroup]) return false;

  return (ROLES[contactGroup] as readonly Permission[]).includes(permission);
}
